import { useTranslation } from "react-i18next";
import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import { Box, CircularProgress, Typography } from "@material-ui/core";

export const PieChartComponent = ({ loading, pieChartData }) => {
  const { t } = useTranslation();

  return (
    <div className="card  card-style pie-chart-card">
      <div className="card-head">
        <Box>
        <Typography variant="body2" style={{color:"#006B7A", fontWeight:'bold', fontSize: '0.6vw'}} >
          {t("text_total_school_fees")}
        </Typography>
        <Typography variant="body1">
          {t("text_received_vs_pending")}
        </Typography>
        </Box>
        <div className="form-select my-select"></div>
      </div>
      <div className="card-body">
        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_details")}
          </div>
        ) : (
          <>
            <div>
              <div className="chart-wrapper">
                <PieChart
                  animate
                  animationDuration={500}
                  animationEasing="ease-out"
                  center={[50, 50]}
                  data={pieChartData}
                  lengthAngle={360}
                  paddingAngle={0}
                  radius={50}
                  startAngle={180}
                  viewBoxSize={[100, 100]}
                  labelPosition={60}
                  label={({ dataEntry }) =>
                    `${Math.round(dataEntry.percentage)} %`
                  }
                  labelStyle={{
                    fontSize: "12px",
                    fontWeight: "700",
                    fill: "white",
                  }}
                />
              </div>
            </div>
            <div className="chart-values">
              <div className="value-box">
                <p className="heading">
                  <span className="icon">
                    <div
                      style={{
                        width: 19,
                        height: 19,
                        backgroundColor: "#82BCC0",
                        borderRadius: "50%",
                      }}
                    />
                  </span>
                  <span
                    className="value-title"
                    style={{ color: "#2E294E", fontFamily: "Roboto" }}
                  >
                    {t("text_received")}
                  </span>
                </p>
              </div>
              <div className="value-box">
                <p className="heading">
                  <span className="icon">
                    <div
                      style={{
                        width: 19,
                        height: 19,
                        backgroundColor: "#2D6978",
                        borderRadius: "50%",
                      }}
                    />
                  </span>
                  <span
                    className="value-title"
                    style={{ color: "#2E294E", fontFamily: "Roboto" }}
                  >
                    {t("text_pending")}
                  </span>
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
